import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TagsPieChartView extends Monitoring.Views.Charts.PieChartView

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.tags')
    @title_en = I18n.t('monitoring.dashboard.charts.tags', {'locale': 'en'})
    super(@options)
    @tagsByClientCode = @options.tagsByClientCode
    @name = 'tag'

  getPieData: (name) ->
    if @allTags
      return @allTags
    data = []
    totalTags = 0
    @allFacets = []
    if @facets[name]['terms'].length == 0
      @allFacets = @facets['all_tags']['terms']
    else
      @allFacets = @facets[name]['terms']
    $.each @allFacets, (index, facet) =>
      totalTags += facet.count
    $.each @allFacets, (index, facet) =>
      percentage = ((facet.count / totalTags) * 100).toFixed(2) if totalTags > 0
      name = @tagsByClientCode[facet.term]
      data.push { tag: facet.term, name:name, y: facet.count, visible: @shouldBeShown(name), code: name, percentage: percentage }
    @allTags = data
    return data

  getNewQuery: (event) ->
    query = @searchQuery.deepCopy()
    tag = _.invert(@tagsByClientCode)[event.point.tag] || event.point.tag
    key = if _.isEmpty(query.get('primary_tags')) then 'primary_tags' else 'secondary_tags'
    query.set(key, [tag])
    return query

  shouldBeShown: (term) ->
    return true

  _getChartOptions: ->
    chartOptions = {}
    if @_settings.maximized
      chartOptions =
        legend:
          enabled: true
          labelFormat: "{name} {y}: ({percentage:.2f}%)"
      $.extend(true, chartOptions, @customChartOptions()) if @customChartOptions()
    else
      chartOptions = @customChartOptions() if @customChartOptions()
    return chartOptions

  _getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', 'tags')
    if @shiftedDays
      new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays)
    else
      query
